export default __webpack_public_path__ + "static/media/r200-3.118987e1.png";